var _rect, _rect2, _circle, _text;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgOutlook = function SvgOutlook(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 48 48",
    "aria-hidden": "true"
  }, props), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 8,
    y: 10,
    width: 28,
    height: 28,
    rx: 2,
    fill: "#2B78C4"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 18,
    y: 20,
    width: 28,
    height: 20,
    rx: 2,
    fill: "#1B4F99"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 22,
    cy: 24,
    r: 8,
    fill: "#fff"
  })), _text || (_text = /*#__PURE__*/React.createElement("text", {
    x: 22,
    y: 28,
    fill: "#1B4F99"
  }, "O")));
};
export { SvgOutlook as ReactComponent };
export default "data:image/svg+xml;base64,PHN2ZyB2aWV3Qm94PSIwIDAgNDggNDgiIGFyaWEtaGlkZGVuPSJ0cnVlIj4KCTxyZWN0IHg9IjgiIHk9IjEwIiB3aWR0aD0iMjgiIGhlaWdodD0iMjgiIHJ4PSIyIiBmaWxsPSIjMkI3OEM0IiAvPgoJPHJlY3QgeD0iMTgiIHk9IjIwIiB3aWR0aD0iMjgiIGhlaWdodD0iMjAiIHJ4PSIyIiBmaWxsPSIjMUI0Rjk5IiAvPgoJPGNpcmNsZSBjeD0iMjIiIGN5PSIyNCIgcj0iOCIgZmlsbD0iI2ZmZiIgLz4KCTx0ZXh0IHg9IjIyIiB5PSIyOCIgZm9udFNpemU9IjEwIiB0ZXh0QW5jaG9yPSJtaWRkbGUiIGZpbGw9IiMxQjRGOTkiIGZvbnRGYW1pbHk9InVpLXNhbnMtc2VyaWYsIHN5c3RlbS11aSI+TzwvdGV4dD4KPC9zdmc+";